import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import card_services from "services/card_services";
import { networkTypeSelector } from "store/userSliceHelpers";
import type { CardApiRecord } from "utils/AxiosUtil";

export function useCards() {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  return useQuery<CardApiRecord[]>({
    queryKey: ["cards"],
    queryFn: () => card_services.fetchCards(networkType),
    enabled: !!user,
  });
}
